import './B2BChart.css';

import React, { useEffect, useState } from 'react';
import { generateClassName } from '../../../b2b-common/helpers';
import ReactECharts from 'echarts-for-react';
import BooleanIconToggle from '../../../b2b-common/BooleanIconToggle';
import { AdsClick, EventAvailable, EventBusy, HighlightOff, ZoomIn, ZoomOut } from '@mui/icons-material';
import hash from 'object-hash';
import { getCurrentDateSeries } from './optionsHelper';

const B2BChart = ({ options, enableZoom = false, enableShowToday = true, enableShowObjectives = true, className }) => {

    const [usedZoom, setUsedZoom] = useState(false);
    const [currentZoomValue, setCurrentZoomValue] = useState(false);
    const [currentOptions, setCurrentOptions] = useState(options);

    const minDate = options.xAxis.min;
    const maxDate = options.xAxis.max;
    const currentDate = new Date().toISOString();
    const isCurrentDateInRange = new Date(currentDate) >= new Date(minDate) && new Date(currentDate) <= new Date(maxDate);
    const [showToday, setShowToday] = React.useState(true);

    const [showObjectives, setShowObjectives] = React.useState(true);

    useEffect(() => {
        const newOptions = {
            ...options,
            series: [
                ...options.series,
                ...getCurrentDateSeries(isCurrentDateInRange, currentDate, options.yAxis)
            ]
        };
        setCurrentOptions(newOptions);
        setCurrentZoomValue(false);
        setUsedZoom(false);
        setShowToday(true);
        setShowObjectives(true);
    }, [options]);

    const handleZoomInZoomOut = (value) => {
        // console.log('handleZoomInZoomOut', value);
        setCurrentZoomValue(value);
        setUsedZoom(true);

        if (value) {
            setCurrentOptions({
                ...options,
                dataZoom: [
                    {
                        type: 'inside', // Enables a slider for zooming
                        xAxisIndex: 0, // Applies to the x-axis
                        start: 0, // Start position of the slider
                        end: 100 // End position of the slider
                    },
                    {
                        type: 'inside', // Enables zooming by mouse wheel or touch gestures
                        xAxisIndex: 0, // Applies to the x-axis
                        start: 0, // Start position of the zoom
                        end: 100 // End position of the zoom
                    }
                ]
            });
        } else {
            setCurrentOptions({
                ...options,
                dataZoom: []
            });
        }

        setTimeout(() => {
            setCurrentZoomValue(value);
        }, 100);
    };

    const handleChangeInShowToday = (value) => {
        setShowToday(value);
        if (!value) {
            setCurrentOptions({
                ...currentOptions,
                series: currentOptions.series.filter(series => (series && !series.isCurrentDate))
            });
        } else {
            setCurrentOptions({
                ...currentOptions,
                series: [
                    ...currentOptions.series,
                    ...getCurrentDateSeries(isCurrentDateInRange, currentDate, currentOptions.yAxis)
                ]
            });
        }
    };

    const isSeriesItemObjective = (seriesItem) => {
        if (!seriesItem) {
            return false;
        }
        if (seriesItem.type === 'line') {
            return seriesItem.isObjective;
        } else if (seriesItem.type === 'custom') {
            // console.log('isSeriesItemObjective', seriesItem);
            if (seriesItem.data.length === 1)
                return seriesItem.data[0].isObjective;
            else
                return false;
        } else {
            return false;
        }
    };

    const handleChangeShowObjectives = (value) => {
        setShowObjectives(value);
        // console.log('handleChangeShowObjectives series', currentOptions.series);
        if (!value) {
            setCurrentOptions({
                ...currentOptions,
                series: currentOptions.series.filter(seriesItem => !isSeriesItemObjective(seriesItem))
            });
        } else {
            setCurrentOptions({
                ...currentOptions,
                series: [
                    ...currentOptions.series,
                    ...options.series.filter(seriesItem => isSeriesItemObjective(seriesItem))
                ]
            });
        }
    };

    return (
        <div className={generateClassName('b2b-chart', '-container', className)}>
            <ReactECharts
                key={hash(currentOptions)}
                option={currentOptions}
                className={generateClassName('b2b-chart', '-echart', className)}
                style={{ height: '100%', width: '100%' }}
            />
            {enableZoom && (
                <div className={generateClassName('b2b-chart', '-zoom-container', className)}>
                    <BooleanIconToggle
                        value={currentZoomValue}
                        onChange={handleZoomInZoomOut}
                        trueIcon={<ZoomOut />}
                        trueText={'Disable zoom'}
                        falseIcon={<ZoomIn />}
                        falseText={'Enable/Reset zoom'}
                        className={`b2b-chart-zoom-toggle ${usedZoom ? 'zoom-used' : ''}`}
                    />
                </div>
            )}
            {enableShowToday && isCurrentDateInRange && (
                <div className={generateClassName('b2b-chart', '-show-today-container', className)}>
                    <BooleanIconToggle
                        value={showToday}
                        onChange={handleChangeInShowToday}
                        trueIcon={<EventBusy />}
                        trueText={'Hide today'}
                        falseIcon={<EventAvailable />}
                        falseText={'Show today'}
                        className='b2b-chart-today-toggle'
                    />
                </div>
            )}
            {enableShowObjectives && (
                <div className={generateClassName('b2b-chart', '-show-objectives-container', className)}>
                    <BooleanIconToggle
                        value={showObjectives}
                        onChange={handleChangeShowObjectives}
                        trueIcon={<HighlightOff />}
                        trueText={'Hide objectives'}
                        falseIcon={<AdsClick />}
                        falseText={'Show objectives'}
                        className='b2b-chart-objectives-toggle'
                    />
                </div>
            )}
        </div>
    );
};

export default B2BChart;